export const ONTOLOGIES_SET = 'ONTOLOGIES_SET';
export const TRAINING_OBJECTIVES_SET = 'TRAINING_OBJECTIVES_SET';
export const INCIDENT_FOLDERS_SET = 'INCIDENT_FOLDERS_SET';
export const WORK_PACKAGES_SET = 'WORK_PACKAGES_SET';
export const INCIDENTS_SET = 'INCIDENTS_SET';
export const TASKS_SET = 'TASKS_SET';
export const INJECTIONS_SET = 'INJECTIONS_SET';
export const PROJECTINPUTS_SET = 'PROJECTINPUTS_SET';
export const ACTIONS_SET = 'ACTIONS_SET';
export const KANBANS_SET = 'KANBANS_SET';
export const OUTCOMES_SET = 'OUTCOMES_SET';
export const DELIVERABLES_SET = 'DELIVERABLES_SET';
export const OBSERVATION_TASKS_SET = 'OBSERVARTION_TASKS_SET';
export const TESTS_SET = 'TESTS_SET';
export const USERS_SET = 'USERS_SET';
export const USER_RIGHTS_SET = 'USER_RIGHTS_SET';
export const USER_RIGHTS_EDITED = 'USER_RIGHTS_EDITED';
export const CONFIGURATION_CHANGE_REQUEST_SET = 'CONFIGURATION_CHANGE_REQUEST_SET';
export const TROUBLE_TICKET_SET = 'TROUBLE_TICKET_SET';
export const TECHNICAL_SUPPORT_REQUEST_SET = 'TECHNICAL_SUPPORT_REQUEST_SET';
export const EXPERIMENTATION_SET = 'EXPERIMENTATION_SET';
export const STATE_SET = 'STATE_SET';
export const TRANSACTION_SET = 'TRANSACTION_SET';
export const RESOURCE_SET = 'RESOURCE_SET';
export const LINE_OF_EFFORT_SET = 'LINE_OF_EFFORT_SET';
export const PLAN_ORDER_REPORT_PROCESS_SET = 'PLAN_ORDER_REPORT_PROCESS_SET';

export const PERMISSIONS_SET = 'PERMISSIONS_SET';
export const USERROLEPERMISSIONS_SET = 'USERROLEPERMISSIONS_SET';
export const USERLOCALPERMISSIONS_SET = 'USERLOCALPERMISSIONS_SET';
export const USERALLDATABASESPERMISSIONS_SET = 'USERALLDATABASESPERMISSIONS_SET';
export const FIELDS_SET = 'FIELDS_SET';
export const FIELD_ADD = 'FIELD_ADD';

export const LINE_OF_EFFORT_ADDED = 'LINE_OF_EFFORT_ADDED';

export const PHASE_SET = 'PHASE_SET';

export const PHASE_ADDED = 'PHASE_ADDED';
export const PHASE_EDITED = 'PHASE_EDITED';
export const PHASE_DELETED = 'PHASE_DELETED';

export const PLAN_ORDER_REPORT_PROCESS_ADDED = 'PLAN_ORDER_REPORT_PROCESS_ADDED';
export const PLAN_ORDER_REPORT_PROCESS_EDITED = 'PLAN_ORDER_REPORT_PROCESS_EDITED';
export const PLAN_ORDER_REPORT_PROCESS_DELETED = 'PLAN_ORDER_REPORT_PROCESS_DELETED';
export const ONTOLOGY_ADDED = 'ONTOLOGY_ADDED';
export const ONTOLOGY_EDITED = 'ONTOLOGY_EDITED';
export const ONTOLOGY_DELETED = 'ONTOLOGY_DELETED';
export const ONTOLOGIES_DELETED = 'ONTOLOGIES_DELETED';
export const TRAINING_OBJECTIVE_ADDED = 'TRAINING_OBJECTIVE_ADDED';
export const TRAINING_OBJECTIVE_EDITED = 'TRAINING_OBJECTIVE_EDITED';
export const INCIDENT_FOLDER_ADDED = 'INCIDENT_FOLDER_ADDED';
export const WORK_PACKAGE_ADDED = 'WORK_PACKAGE_ADDED';
export const INCIDENT_FOLDER_EDITED = 'INCIDENT_FOLDER_EDITED';
export const WORK_PACKAGE_EDITED = 'WORK_PACKAGE_EDITED';
export const INCIDENT_ADDED = 'INCIDENT_ADDED';
export const TASK_ADDED = 'TASK_ADDED';
export const INCIDENT_EDITED = 'INCIDENT_EDITED';
export const TASK_EDITED = 'TASK_EDITED';
export const TROUBLE_TICKET_EDITED = 'TROUBLE_TICKET_EDITED';
export const PERMISSIONS_EDITED = 'PERMISSIONS_EDITED';
export const USERROLEPERMISSIONS_EDITED = 'USERROLEPERMISSIONS_EDITED';

export const INJECTION_ADDED = 'INJECTION_ADDED';
export const INJECTION_EDITED = 'INJECTION_EDITED';
export const PROJECTINPUT_ADDED = 'PROJECTINPUT_ADDED';
export const PROJECTINPUT_EDITED = 'PROJECTINPUT_EDITED';
export const ACTION_ADDED = 'ACTION_ADDED';
export const ACTION_EDITED = 'ACTION_EDITED';
export const KANBAN_ADDED = 'KANBAN_ADDED';
export const KANBAN_EDITED = 'KANBAN_EDITED';

export const OUTCOME_ADDED = 'OUTCOME_ADDED';
export const OUTCOME_EDITED = 'OUTCOME_EDITED';
export const DELIVERABLE_ADDED = 'DELIVERABLE_ADDED';
export const DELIVERABLE_EDITED = 'DELIVERABLE_EDITED';
export const OBSERVATION_TASK_ADDED = 'OBSERVATION_TASK_ADDED';
export const OBSERVATION_TASK_EDITED = 'OBSERVATION_TASK_EDITED';
export const TEST_ADDED = 'TEST_ADDED';
export const TEST_EDITED = 'TEST_EDITED';
export const USER_RIGHTS_ADDED = 'USER_RIGHTS_ADDED';
export const CONFIGURATION_CHANGE_REQUEST_ADDED = 'CONFIGURATION_CHANGE_REQUEST_ADDED';
export const CONFIGURATION_CHANGE_REQUEST_EDITED = 'CONFIGURATION_CHANGE_REQUEST_EDITED';
export const TECHNICAL_SUPPORT_REQUEST_ADDED = 'TECHNICAL_SUPPORT_REQUEST_ADDED';
export const TECHNICAL_SUPPORT_REQUEST_EDITED = 'TECHNICAL_SUPPORT_REQUEST_EDITED';

export const TRANSACTION_EDITED = 'TRANSACTION_EDITED';

export const TROUBLE_TICKET_ADDED = 'TROUBLE_TICKET_ADDED';
export const EXPERIMENTATION_ADDED = 'EXPERIMENTATION_ADDED';
export const EXPERIMENTATION_STATUS_UPDATE = 'EXPERIMENTATION_STATUS_UPDATE';
export const EXPERIMENTATION_REPORT_SET = 'EXPERIMENTATION_REPORT_SET';
export const STATE_ADDED = 'STATE_ADDED';
export const STATE_EDITED = 'STATE_EDITED';
export const TRANSACTION_ADDED = 'TRANSACTION_ADDED';
export const RESOURCE_ADDED = 'RESOURCE_ADDED';
export const PERMISSIONS_ADDED = 'PERMISSIONS_ADDED';
export const USERROLEPERMISSIONS_ADDED = 'USERROLEPERMISSIONS_ADDED';

export const INCIDENT_FOLDER_DELETED = 'INCIDENT_FOLDER_DELETED';
export const WORK_PACKAGE_DELETED = 'WORK_PACKAGE_DELETED';
export const INCIDENT_DELETED = 'INCIDENT_DELETED';
export const TASK_DELETED = 'TASK_DELETED';
export const INJECTION_DELETED = 'INJECTION_DELETED';
export const PROJECTINPUT_DELETED = 'PROJECTINPUT_DELETED';
export const ACTION_DELETED = 'ACTION_DELETED';
export const KANBAN_DELETED = 'KANBAN_DELETED';
export const OUTCOME_DELETED = 'OUTCOME_DELETED';
export const DELIVERABLE_DELETED = 'DELIVERABLE_DELETED';
export const OBSERVATION_TASK_DELETED = 'OBSERVATION_TASK_DELETED';
export const TEST_DELETED = 'TEST_DELETED';

export const EXPERIMENTATION_DELETED = 'EXPERIMENTATION_DELETED';

export const TRAINING_OBJECTIVE_DELETED = 'TRAINING_OBJECTIVE_DELETED';
export const CONFIGURATION_CHANGE_REQUEST_DELETED = 'CONFIGURATION_CHANGE_REQUEST_DELETED';
export const TROUBLE_TICKET_DELETED = 'TROUBLE_TICKET_DELETED';
export const TECHNICAL_SUPPORT_REQUEST_DELETED = 'TECHNICAL_SUPPORT_REQUEST_DELETED';
export const USERROLEPERMISSIONS_DELETED = 'USERROLEPERMISSIONS_DELETED';
export const TRANSACTION_DELETED = 'TRANSACTION_DELETED';
export const STATE_DELETED = 'STATE_DELETED';

export const LILL_SET = 'LILL_SET';
export const LILL_DELETED = 'LILL_DELETED';
export const LILL_ADDED = 'LILL_ADDED';
export const LILL_EDITED = 'LILL_EDITED';

export const REGISTRY_ADDED = 'REGISTRY_ADDED';
export const REGISTRY_SET = 'REGISTRY_SET';
export const REGISTRY_DELETED = 'REGISTRY_DELETED';
export const REGISTRY_EDITED = 'REGISTRY_EDITED';

export const PARAMETER_SET = 'PARAMETER_SET';
export const PARAMETER_EDITED = 'PARAMETER_EDITED';

export const SETTING_ADDED = 'SETTING_ADDED';
export const SETTING_SET = 'SETTING_SET';
export const SETTING_DELETED = 'SETTING_DELETED';
export const SETTING_EDITED = 'SETTING_EDITED';

export const ROAD_TO_CURRENT_SETTINGS_SET = 'ROAD_TO_CURRENT_SETTINGS_SET';
export const ROAD_TO_CURRENT_SETTINGS_ADDED = 'ROAD_TO_CURRENT_SETTINGS_ADDED';
export const ROAD_TO_CURRENT_SETTINGS_UPDATED = 'ROAD_TO_CURRENT_SETTINGS_UPDATED';
export const ROAD_TO_CURRENT_SETTINGS_DELETED = 'ROAD_TO_CURRENT_SETTINGS_DELETED';

export const BATTLE_RHYTHMS_SET = 'BATTLE_RHYTHMS_SET';
export const BATTLE_RHYTHM_ADDED = 'BATTLE_RHYTHM_ADDED';
export const BATTLE_RHYTHM_EDITED = 'BATTLE_RHYTHM_EDITED';
export const BATTLE_RHYTHM_DELETED = 'BATTLE_RHYTHM_DELETED';

export const EFFECT_SET = 'EFFECT_SET';
export const EFFECT_ADDED = 'EFFECT_ADDED';
export const EFFECT_EDITED = 'EFFECT_EDITED';
export const EFFECT_DELETED = 'EFFECT_DELETED';

export const OD_TASK_SET = 'OD_TASK_SET';
export const OD_TASK_ADDED = 'OD_TASK_ADDED';
export const OD_TASK_EDITED = 'OD_TASK_EDITED';
export const OD_TASK_DELETED = 'OD_TASK_DELETED';

export const DECISIVE_CONDITION_SET = 'DECISIVE_CONDITION_SET';
export const DECISIVE_CONDITION_ADDED = 'DECISIVE_CONDITION_ADDED';
export const DECISIVE_CONDITION_EDITED = 'DECISIVE_CONDITION_EDITED';
export const DECISIVE_CONDITION_DELETED = 'DECISIVE_CONDITION_DELETED';
export const LINE_OF_EFFORT_EDITED = 'LINE_OF_EFFORT_EDITED';
export const LINE_OF_EFFORT_DELETED = 'LINE_OF_EFFORT_DELETED';

export const TURNCHART_SET = 'TURNCHART_SET';
export const TURNCHART_ADDED = 'TURNCHART_ADDED';
export const TURNCHART_EDITED = 'TURNCHART_EDITED';
export const TURNCHART_DELETED = 'TURNCHART_DELETED';

export const PROJECTS_SET = 'PROJECTS_SET';
export const PROJECT_ADDED = 'PROJECT_ADDED';
export const PROJECT_EDITED = 'PROJECT_EDITED';
export const PROJECT_DELETED = 'PROJECT_DELETED';

export const COA_SET = 'COA_SET';
export const COA_ADDED = 'COA_ADDED';
export const COA_EDITED = 'COA_EDITED';
export const COA_DELETED = 'COA_DELETED';

export const RISK_SET = 'RISK_SET';
export const RISK_ADDED = 'RISK_ADDED';
export const RISK_EDITED = 'RISK_EDITED';
export const RISK_DELETED = 'RISK_DELETED';
